(() => {
  const body = document.querySelector('.shopify-policy__body');
  if (!body || document.querySelector('.abdeen-policy-nav')) return;
  // This Arabic refund policy stores full paragraphs in h3 elements.
  if (document.documentElement.lang.startsWith('ar') && location.pathname.endsWith('/policies/refund-policy')) {
    body.querySelectorAll('h3').forEach(heading => {
      if (heading.textContent.trim().length <= 120) return;
      const paragraph = document.createElement('p');
      paragraph.className = 'abdeen-policy-paragraph';
      while (heading.firstChild) paragraph.append(heading.firstChild);
      heading.replaceWith(paragraph);
    });
  }
  const headings = [...body.querySelectorAll('h1,h2,h3,h4,h5,h6')].filter(el => el.textContent.trim());
  if (headings.length < 2) return;
  const details = document.createElement('details');
  details.className = 'abdeen-policy-nav';
  const summary = document.createElement('summary');
  summary.textContent = document.body.dataset.policyContents;
  details.append(summary);
  const nav = document.createElement('nav');
  nav.setAttribute('aria-label', summary.textContent);
  const list = document.createElement('ul');
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `abdeen-policy-section-${index + 1}`;
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
  });
  nav.append(list);
  details.append(nav);
  body.before(details);
})();
